<template>
  <main class="mypage-redesign">
    <!-- 메인 콘텐츠 영역 -->
    <div class="mypage-container">
      <!-- MypageSidebar 컴포넌트 -->
      <MypageSidebar />

      <!-- 메인 콘텐츠 -->
      <div class="main-content">
        <!-- 나의 게시글 섹션 -->
        <section class="post-section">
          <div class="section-header">
            <div>
              <h2 class="section-title">내가 작성한 글</h2>
              <p class="section-description">작성한 게시글을 관리하실 수 있습니다</p>
            </div>
          </div>

          <!-- 게시판 필터 -->
          <div class="filter-section">
            <div class="filter-row">
              <label class="filter-label">게시판 선택</label>
              <div class="custom-select">
                <select v-model="selectedBoard" @change="getPostList">
                  <option value="">전체</option>
                  <option value="5">영유아부</option>
                  <option value="6">유치부</option>
                  <option value="7">유년부</option>
                  <option value="8">초등부</option>
                  <option value="9">청소년부</option>
                  <option value="10">대학청년부</option>
                  <option value="11">구역/장년</option>
                </select>
              </div>
            </div>
          </div>

          <!-- 게시글 리스트 -->
          <div v-if="postList.length > 0" class="post-list">
            <div v-for="post in postList" :key="post.postId" class="post-item">
              <div class="post-number">{{ post.seq }}</div>
              <div class="post-main">
                <router-link :to="`/board/${post.boardId}/${post.postId}`" class="post-title-link">
                  <div class="post-title-wrapper">
                    <!-- 비밀글 아이콘 -->
                    <svg v-if="post.isSecret === true" class="secret-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
                      <path d="M8.99992 4.66671H8.41658V3.50004C8.41658 1.89004 7.10992 0.583374 5.49992 0.583374C3.88992 0.583374 2.58325 1.89004 2.58325 3.50004V4.66671H1.99992C1.35825 4.66671 0.833252 5.19171 0.833252 5.83337V11.6667C0.833252 12.3084 1.35825 12.8334 1.99992 12.8334H8.99992C9.64159 12.8334 10.1666 12.3084 10.1666 11.6667V5.83337C10.1666 5.19171 9.64159 4.66671 8.99992 4.66671ZM5.49992 9.91671C4.85825 9.91671 4.33325 9.39171 4.33325 8.75004C4.33325 8.10837 4.85825 7.58337 5.49992 7.58337C6.14159 7.58337 6.66658 8.10837 6.66658 8.75004C6.66658 9.39171 6.14159 9.91671 5.49992 9.91671ZM3.74992 4.66671V3.50004C3.74992 2.53171 4.53159 1.75004 5.49992 1.75004C6.46825 1.75004 7.24992 2.53171 7.24992 3.50004V4.66671H3.74992Z" fill="#B7BABD"/>
                    </svg>

                    <h3 class="post-title">{{ post.postTitle }}</h3>

                    <!-- 댓글 수 -->
                    <span v-if="post.commentCount > 0" class="comment-badge">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                        <path d="M5.93757 6C5.93757 6.14918 5.99683 6.29226 6.10232 6.39775C6.20781 6.50324 6.35088 6.5625 6.50007 6.5625C6.64925 6.5625 6.79232 6.50324 6.89781 6.39775C7.0033 6.29226 7.06257 6.14918 7.06257 6C7.06257 5.85082 7.0033 5.70774 6.89781 5.60225C6.79232 5.49676 6.64925 5.4375 6.50007 5.4375C6.35088 5.4375 6.20781 5.49676 6.10232 5.60225C5.99683 5.70774 5.93757 5.85082 5.93757 6ZM8.28132 6C8.28132 6.14918 8.34058 6.29226 8.44607 6.39775C8.55156 6.50324 8.69463 6.5625 8.84382 6.5625C8.993 6.5625 9.13607 6.50324 9.24156 6.39775C9.34705 6.29226 9.40632 6.14918 9.40632 6C9.40632 5.85082 9.34705 5.70774 9.24156 5.60225C9.13607 5.49676 8.993 5.4375 8.84382 5.4375C8.69463 5.4375 8.55156 5.49676 8.44607 5.60225C8.34058 5.70774 8.28132 5.85082 8.28132 6ZM3.59382 6C3.59382 6.14918 3.65308 6.29226 3.75857 6.39775C3.86406 6.50324 4.00713 6.5625 4.15632 6.5625C4.3055 6.5625 4.44858 6.50324 4.55406 6.39775C4.65955 6.29226 4.71882 6.14918 4.71882 6C4.71882 5.85082 4.65955 5.70774 4.55406 5.60225C4.44858 5.49676 4.3055 5.4375 4.15632 5.4375C4.00713 5.4375 3.86406 5.49676 3.75857 5.60225C3.65308 5.70774 3.59382 5.85082 3.59382 6ZM11.3423 3.96562C11.0774 3.33633 10.6977 2.77148 10.2137 2.28633C9.73314 1.80398 9.16261 1.42057 8.53444 1.15781C7.88991 0.887109 7.20554 0.75 6.50007 0.75H6.47663C5.76647 0.753516 5.07858 0.894141 4.43171 1.1707C3.80892 1.43616 3.24373 1.82025 2.76764 2.30156C2.28835 2.78555 1.91218 3.34805 1.65202 3.975C1.38249 4.62422 1.24655 5.31445 1.25007 6.02461C1.25404 6.83844 1.44658 7.64028 1.81257 8.36719V10.1484C1.81257 10.2914 1.86936 10.4285 1.97045 10.5296C2.07155 10.6307 2.20866 10.6875 2.35163 10.6875H4.13405C4.86096 11.0535 5.6628 11.246 6.47663 11.25H6.50124C7.20319 11.25 7.88405 11.1141 8.52507 10.848C9.15006 10.5884 9.71846 10.2095 10.1985 9.73242C10.6825 9.25313 11.0633 8.69297 11.3294 8.06836C11.6059 7.42148 11.7466 6.73359 11.7501 6.02344C11.7536 5.30977 11.6153 4.61719 11.3423 3.96562ZM9.57155 9.09844C8.75007 9.91172 7.66022 10.3594 6.50007 10.3594H6.48014C5.7735 10.3559 5.07155 10.1801 4.45163 9.84961L4.35319 9.79688H2.70319V8.14688L2.65046 8.04844C2.31999 7.42852 2.14421 6.72656 2.14069 6.01992C2.136 4.85156 2.58249 3.75469 3.40163 2.92852C4.2196 2.10234 5.31296 1.64531 6.48132 1.64062H6.50124C7.08718 1.64062 7.65554 1.7543 8.19108 1.9793C8.71374 2.19844 9.18249 2.51367 9.58561 2.9168C9.98757 3.31875 10.304 3.78867 10.5231 4.31133C10.7505 4.85273 10.8641 5.42695 10.8618 6.01992C10.8548 7.18711 10.3966 8.28047 9.57155 9.09844Z" fill="#898C92"/>
                      </svg>
                      <span class="comment-count">{{ post.commentCount }}</span>
                    </span>
                  </div>
                </router-link>
                <div class="post-meta">
                  <span class="post-author">{{ post.postAuthor }}</span>
                  <span class="meta-separator">·</span>
                  <span class="post-date">{{ formDate(post.createdDateTime) }}</span>
                  <span class="meta-separator">·</span>
                  <span class="post-views">조회 {{ post.postHit }}</span>
                </div>
              </div>
            </div>

            <!-- 페이지네이션 -->
            <pagination v-if="pageInfo.page" :pageInfo="pageInfo" :page="page" :size="size" @updatePage="updatePage" />
          </div>

          <!-- 빈 상태 -->
          <div v-else class="empty-state">작성한 게시글이 없습니다.</div>
        </section>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import store from "@/store";
import MypageSidebar from "@/components/MypageSidebar.vue";
import Pagination from "@/components/Pagination.vue";
import { formDate } from "@/assets/js/util.js";

const pageInfo = ref({});
const postList = ref([]);

const page = ref(1);
const size = ref(12);

const memberIdx = store.state.account.id;
const selectedBoard = ref("");

// 게시글 목록 조회
const getPostList = async () => {
  try {
    const res = await axios.get(
      `/new_api/post/list?page=${page.value}&size=${size.value}&memberIdx=${memberIdx}&boardId=${selectedBoard.value}`
    );
    pageInfo.value = res.data.data.pageInfo;
    postList.value = res.data.data.postList;
  } catch (err) {
    console.error(err);
  }
};

const updatePage = (num) => {
  page.value = num;
  getPostList();
};

onMounted(async () => {
  await getPostList();
});
</script>

<style scoped lang="scss">
/* ========================================
   Variables & Reset
   ======================================== */
.mypage-redesign {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 0;
  font-family: "Pretendard", "Malgun Gothic", sans-serif;
}

/* ========================================
   Main Container
   ======================================== */
.mypage-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  display: grid;
  grid-template-columns: 230px 1fr;
  gap: 40px;

  @media (max-width: 1023px) {
    grid-template-columns: 240px 1fr;
    gap: 32px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding: 20px 16px 40px;
  }
}

/* ========================================
   Main Content
   ======================================== */
.main-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ========================================
   Post Section
   ======================================== */
.post-section {
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  color: #222;
  margin: 0 0 8px 0;

  @media (max-width: 767px) {
    font-size: 20px;
  }
}

.section-description {
  font-size: 14px;
  color: #888;
  margin: 0;
}

/* ========================================
   Filter Section
   ======================================== */
.filter-section {
  background: #f5f7fa;
  border: 1px solid #dee0e3;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;

  @media (max-width: 767px) {
    padding: 16px;
  }
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}

.filter-label {
  font-size: 14px;
  font-weight: 600;
  color: #222;
  min-width: 100px;

  @media (max-width: 767px) {
    min-width: auto;
  }
}

.custom-select {
  flex: 1;

  select {
    width: 100%;
    max-width: 300px;
    padding: 12px 16px;
    background: #ffffff;
    border: 1px solid #dee0e3;
    border-radius: 8px;
    font-size: 14px;
    color: #555961;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #0c3388;
    }

    &:focus {
      outline: none;
      border-color: #0c3388;
      box-shadow: 0 0 0 3px rgba(12, 51, 136, 0.1);
    }

    @media (max-width: 767px) {
      max-width: 100%;
    }
  }
}

/* ========================================
   Post List
   ======================================== */
.post-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.post-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s;

  &:first-child {
    border-top: 1px solid #dee0e3;
  }

  &:hover {
    background: #f9fafb;
  }

  @media (max-width: 767px) {
    gap: 12px;
    padding: 16px 12px;
  }
}

.post-number {
  flex-shrink: 0;
  width: 50px;
  font-size: 14px;
  font-weight: 500;
  color: #888;
  text-align: center;
  padding-top: 2px;

  @media (max-width: 767px) {
    width: 40px;
    font-size: 13px;
  }
}

.post-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.post-title-link {
  text-decoration: none;
  color: inherit;

  &:hover .post-title {
    color: #0c3388;
  }
}

.post-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.secret-icon {
  flex-shrink: 0;
  width: 11px;
  height: 13px;
}

.post-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.2s;

  @media (max-width: 767px) {
    font-size: 15px;
  }
}

.comment-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  svg {
    width: 13px;
    height: 12px;
  }

  .comment-count {
    font-size: 13px;
    color: #898c92;
  }
}

.post-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #888;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    font-size: 13px;
    gap: 6px;
  }
}

.post-author {
  color: #555961;
  font-weight: 500;
}

.meta-separator {
  color: #d2d6dc;
}

.post-date,
.post-views {
  color: #888;
}

/* ========================================
   Empty State
   ======================================== */
.empty-state {
  padding: 60px 24px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #dee0e3;
  margin-top: 0;
}

/* ========================================
   Focus Styles
   ======================================== */
*:focus-visible {
  outline: 2px solid #0c3388;
  outline-offset: 2px;
}
</style>
